import logo1 from "../../static/images/typeDiagnosis/typequestionLogo9.png";
import logo2 from "../../static/images/typeDiagnosis/typequestionLogo10.png";
import logo3 from "../../static/images/typeDiagnosis/typequestionLogo11.png";
import logo4 from "../../static/images/typeDiagnosis/typequestionLogo12.png";
import logo5 from "../../static/images/typeDiagnosis/typequestionLogo13.png";
import logo6 from "../../static/images/typeDiagnosis/typequestionLogo14.png";
import logo7 from "../../static/images/typeDiagnosis/typequestionLogo15.png";
import logo8 from "../../static/images/typeDiagnosis/typequestionLogo1.png";
import logo9 from "../../static/images/typeDiagnosis/typequestionLogo2.png";
import logo10 from "../../static/images/typeDiagnosis/typequestionLogo3.png";
import logo11 from "../../static/images/typeDiagnosis/typequestionLogo4.png";
import logo12 from "../../static/images/typeDiagnosis/typequestionLogo5.png";
import logo13 from "../../static/images/typeDiagnosis/typequestionLogo6.png";
import logo14 from "../../static/images/typeDiagnosis/typequestionLogo7.png";
import logo15 from "../../static/images/typeDiagnosis/typequestionLogo8.png";

import { DiagnosisQuestion } from "../../organism/diagnosis-question/DiagnosisQuestion";

export const diagnosisQuestionList: DiagnosisQuestion[] = [
  {
    logo: logo1,
    questionNo: 1,
    question: ["お金のことを、お子さんと話すことはありますか？（予定も含む）"],
    answerList: [
      {
        answerNo: 1,
        answer: "週1回以上",
      },
      {
        answerNo: 2,
        answer: "月1回くらい",
      },
      {
        answerNo: 3,
        answer: "年1回くらい",
      },
      {
        answerNo: 4,
        answer: "ほとんど話していない",
      },
    ],
  },
  {
    logo: logo2,
    questionNo: 2,
    question: [
      "将来の夢や目標について、お子さんと話すことはありますか？（予定も含む）",
    ],
    answerList: [
      {
        answerNo: 1,
        answer: "週1回以上",
      },
      {
        answerNo: 2,
        answer: "月1回くらい",
      },
      {
        answerNo: 3,
        answer: "年1回くらい",
      },
      {
        answerNo: 4,
        answer: "ほとんど話していない",
      },
    ],
  },
  {
    logo: logo3,
    questionNo: 3,
    question: ["お子さんのおこづかいは、どのように渡していますか？（予定も含む）"],
    answerList: [
      {
        answerNo: 1,
        answer: "定額制（毎月決まった金額）",
      },
      {
        answerNo: 2,
        answer: "報酬制（お手伝いのごほうびなど）",
      },
      {
        answerNo: 3,
        answer: "都度払い（必要なときにその都度）",
      },
      {
        answerNo: 4,
        answer: "その他",
      },
    ],
  },
  {
    logo: logo4,
    questionNo: 4,
    question: ["お金の使い方について、ルールは決めていますか？（気持ちも含む）"],
    answerList: [
      {
        answerNo: 1,
        answer: "家族みんなでルールを決めている",
      },
      {
        answerNo: 2,
        answer: "親だけルールを決めている",
      },
      {
        answerNo: 3,
        answer: "子ども用のルールを決めている",
      },
      {
        answerNo: 4,
        answer: "特にルールはない",
      },
    ],
  },
  {
    logo: logo5,
    questionNo: 5,
    question: ["ご家族とお金の話をするとき、どんな気持ちになりますか？"],
    answerList: [
      {
        answerNo: 1,
        answer: "いつも通りの気持ち",
      },
      {
        answerNo: 2,
        answer: "ワクワクする",
      },
      {
        answerNo: 3,
        answer: "ちょっとドキドキする",
      },
      {
        answerNo: 4,
        answer: "少しイライラする",
      },
    ],
  },
  {
    logo: logo6,
    questionNo: 6,
    question: ["お子さんにおこづかいを渡す目的は何ですか？（まだの方は予定でもOK）"],
    answerList: [
      {
        "answerNo": 1,
        "answer": "頑張ったことへのごほうびにしたい"
      },
      {
        "answerNo": 2,
        "answer": "必要なものを自分で買ってほしい"
      },
      {
        "answerNo": 3,
        "answer": "貯金の習慣をつけてほしい"
      },
      {
        "answerNo": 4,
        "answer": "特に目的はない"
      }  
    ],
  },
  {
    logo: logo7,
    questionNo: 7,
    question: [
      "お子さんから高額なものをねだられたとき、「買う買わない」はどう決めていますか？（気持ちでもOK）"
    ],
    answerList: [
      {
        "answerNo": 1,
        "answer": "自分ひとりで決める"
      },
      {
        "answerNo": 2,
        "answer": "大人だけで話し合って決める"
      },
      {
        "answerNo": 3,
        "answer": "自分とお子さんで話し合って決める"
      },
      {
        "answerNo": 4,
        "answer": "家族全員で話し合って決める"
      }
    ],
  },
  {
    logo: logo8,
    questionNo: 8,
    question: ["お金に関する知識の中で、特に「身につけたい」と感じるものはどれですか？"],
    answerList: [
      {
        "answerNo": 1,
        "answer": "節約（お金の使い方の工夫）"
      },
      {
        "answerNo": 2,
        "answer": "貯金（お金をためること）"
      },
      {
        "answerNo": 3,
        "answer": "保険（万が一への備え）"
      },
      {
        "answerNo": 4,
        "answer": "投資（お金を増やすしくみ）"
      }
    ],
  },
  {
    logo: logo9,
    questionNo: 9,
    question: ["もし宝くじで100万円当たったら、どう使いたいですか？"],
    answerList: [
      {
        "answerNo": 1,
        "answer": "思いきって使いたい"
      },
      {
        "answerNo": 2,
        "answer": "まずは貯金したい"
      },
      {
        "answerNo": 3,
        "answer": "貯金しながら運用もしたい"
      },
      {
        "answerNo": 4,
        "answer": "将来のために全て運用したい"
      }
    ],
  },
  {
    logo: logo10,
    questionNo: 10,
    question: ["将来に向けたお金の準備（貯金や投資など）は、どのくらいできていますか？"],
    answerList: [
      {
        "answerNo": 1,
        "answer": "しっかりできている"
      },
      {
        "answerNo": 2,
        "answer": "まあまあできている"
      },
      {
        "answerNo": 3,
        "answer": "あまりできていない"
      },
      {
        "answerNo": 4,
        "answer": "ほとんどできていない"
      }  
    ],
  },
  {
    logo: logo11,
    questionNo: 11,
    question: ["家計簿は、どなたがつけていますか？"],
    answerList: [    
    {
      "answerNo": 1,
      "answer": "自分でつけている"
    },
    {
      "answerNo": 2,
      "answer": "パートナーがつけている"
    },
    {
      "answerNo": 3,
      "answer": "他の人がつけている"
    },
    {
      "answerNo": 4,
      "answer": "家計簿はつけていない"
    }
    ],
  },
  {
    logo: logo12,
    questionNo: 12,
    question: ["欲しいけど予算オーバー…そんなとき、あなたはどうしますか？"],
    answerList: [
      {
        "answerNo": 1,
        "answer": "すぐに買ってしまう"
      },
      {
        "answerNo": 2,
        "answer": "その場で少し調べてから買う"
      },
      {
        "answerNo": 3,
        "answer": "しっかり比較してから決める"
      },
      {
        "answerNo": 4,
        "answer": "時間をおいてそれでも欲しければ買う"
      }  
    ],
  },
  {
    logo: logo13,
    questionNo: 13,
    question: ["今入っている保険や投資について、内容をどのくらい理解していますか？"],
    answerList: [
      {
        "answerNo": 1,
        "answer": "しっかり理解している"
      },
      {
        "answerNo": 2,
        "answer": "だいたいはわかっている"
      },
      {
        "answerNo": 3,
        "answer": "あまりよくわかっていない"
      },
      {
        "answerNo": 4,
        "answer": "保険や投資はまだ利用していない"
      }  
    ],
  },
  {
    logo: logo14,
    questionNo: 14,
    question: ["お金をふやす方法を選ぶとしたら、リスクとリターンのバランスはどれが理想ですか？"],
    answerList: [
      {
        "answerNo": 1,
        "answer": "リスクが高くても大きくふやしたい"
      },
      {
        "answerNo": 2,
        "answer": "ほどほどのリスクでそこそこふやしたい"
      },
      {
        "answerNo": 3,
        "answer": "リスクは少なめで少しずつふやしたい"
      },
      {
        "answerNo": 4,
        "answer": "リスクは取りたくない"
      }  
    ],
  },
  {
    logo: logo15,
    questionNo: 15,
    question: ["投資について、これまでに「やってみたい」と思ったことはありますか？"],
    answerList: [
      {
        "answerNo": 1,
        "answer": "すでに始めている"
      },
      {
        "answerNo": 2,
        "answer": "やってみたいと思っている"
      },
      {
        "answerNo": 3,
        "answer": "興味はあるけど少しこわい"
      },
      {
        "answerNo": 4,
        "answer": "今のところ興味はない"
      }  
    ],
  },
];
